import Service from "../Service";

const resource = "packingworkstation/"

export default{

    pagination(dtr, requestID){
        return Service.post(resource + "pagination", dtr,{
            params:{requestID:requestID},
        });
    },
    save(cmp, requestID){
        return Service.post(resource + "save", cmp,{
            params: {requestID: requestID},
        });
    },
    list(fas, requestID) {
        return Service.post(resource + "list", fas, {
          params: { requestID: requestID },
        });
    },
}